import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Redirect } from 'react-router-dom'
import { Modal } from "react-bootstrap";
import Select, { components } from 'react-select';
import moment from 'moment';

import { setCookie, getCookie } from '../common_component/cookie.js';
import { useTheme } from "./theme-provider.js";
import { useAuthData } from "./auth-provider.js";
import PageError from "../common_component/PageError.js";

function EditDeliveryOrder(props) {
    const [state, setstate] = useState(2);
    const { theme, dropdownStyleDark } = useTheme();

    const [chalanList, setChalanList] = useState([])
    const [invoiceList, setInvoiceList] = useState([]);
    const [deliveryAgentList, setDeliveryAgentList] = useState([])
    const [warehouseList, setWarehouseList] = useState([])
    const [orderDetails, setOrderDetails] = useState(null)

    const [chalanListApiState, setChalanListApiState] = useState(false);
    const [invoiceListApiState, setInvoiceListApiState] = useState(false);
    const [shippingProviderListApiState, setShippingProviderListApiState] = useState(false)
    const [deliveryAgentListApiState, setDeliveryAgentListApiState] = useState(false)
    const [vehicleListApiState, setVehicleListApiState] = useState(false)


    const [orderNumber, setOrderNumber] = useState("")
    const [orderType, setOrderType] = useState(null);
    const [orderDate, setOrderDate] = useState(moment.utc().format('YYYY-MM-DD'))

    const [deliveryChalanArray, setDeliveryChalanArray] = useState([{ challan_number: null, challan_id: null, challan_date: moment.utc().format('YYYY-MM-DD') }])

    const [shippingProviderList, setShippingProviderList] = useState([]);
    const [shippingProvider, setShippingProvider] = useState(null);
    const [selectedInvoice, setSelectedInvoice] = useState(null)
    const [selectedDeliveryAgent, setSelectedDeliveryAgent] = useState(null)

    const [selectedWarehouse, setSelectedWarehouse] = useState(null)
    const [selectedVehicle, setSelectedVehicle] = useState(null);
    const [vehicleList, setVehicleList] = useState([])
    const [distanceDetails, setDistanceDetails] = useState({ input_km: 0, calculated_km: 0, source_coords: null, destination_coords: null })

    const [courierName, setCourierName] = useState("")
    const [courierTrackingId, setCourierTrackingId] = useState("")

    const [deliveryInvoiceSubmitButtonState, setDeliveryInvoiceSubmitButtonState] = useState(false)

    const [addressModalShow, setAddressModalShow] = useState(false)
    const [addressType, setAddressType] = useState(null)
    const [invoiceIndexAddress, setInvoiceIndexAddress] = useState(null)
    const [addressId, setAddressId] = useState(null)

    const [gstinModalShow, setGstinModalShow] = useState(false)
    const [invoiceIndexGstin, setInvoiceIndexGstin] = useState(null)
    const [gstinId, setGstinId] = useState(null)

    const [branchList, setBranchlist] = useState([])
    const [transactionSeriesList, setTransactionSeriesList] = useState([])
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [selectedTransactionSeries, setSelectedTransactionSeries] = useState(null);

    const [addDeliveryAgentModalShow, setAddDeliveryAgentModalShow] = useState(false)
    const [deliveryAgentName, setDeliveryAgentName] = useState("")
    const [deliveryAgentPhone, setDeliveryAgentPhone] = useState("")
    const [deliveryAgentEmail, setDeliveryAgentEmail] = useState("")
    const [deliveryAgentCompanyName, setDeliveryAgentCompanyName] = useState("")
    const [deliveryAgentCompanyPhone, setDeliveryAgentCompanyPhone] = useState("")
    const [deliveryAgentCompanyWebsite, setDeliveryAgentCompanyWebsite] = useState("")
    const [deliveryAgentCompanyAddress, setDeliveryAgentCompanyAddress] = useState("")
    const [deliveryAgentSubmitButtonState, setDeliveryAgentSubmitButtonState] = useState(false)

    const apiController = useRef(new AbortController())

    var page_name = "edit-delivery-order";

    const { user, read, write, visibility, organization_id } = useAuthData(page_name);

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    async function getOrderDetails() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-delivery-order-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "id": props.match.params.id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body.data)

        if (body.operation == "success") {
            setOrderDetails(body.data[0])
            return body.data[0]
        }
        else {
            throw "get order details api error"
        }
    }

    async function getAllShippingProvider() {
        try {
            if (shippingProviderListApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            setShippingProviderListApiState(true)
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-all-shipping-providers`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "status_type": "All", "search_value": null, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            if (body.operation !== "success") throw "get ecommerce coupon list api error"

            setShippingProviderList(body.data.list)
            setShippingProviderListApiState(false)
        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    async function getDeliveryAgentBySearch(search_v) {
        setDeliveryAgentListApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-delivery-agent-by-search`, { method: 'POST', body: JSON.stringify({ "email": user.email, "search_value": search_v, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)
        setDeliveryAgentListApiState(false)
        if (body.operation == "success") {
            setDeliveryAgentList(body.data)
        }
    }

    async function getVehicleInformationBySearch(search_v) {
        setVehicleListApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-vehicle-information-by-search`, { method: 'POST', body: JSON.stringify({ "email": user.email, "search_value": search_v, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)
        setVehicleListApiState(false)
        if (body.operation == "success") {
            setVehicleList(body.data)
        }
    }

    async function getWarehouses() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/list-warehouse`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation == "success") {
            setWarehouseList(body.data)

            const defaultWarehouse = body.data.find(obj => obj.default)
            if (defaultWarehouse) {
                setSelectedWarehouse({ label: defaultWarehouse.name, value: defaultWarehouse.wid })
            } else {
                setSelectedWarehouse({ label: body.data[0].name, value: body.data[0].wid })
            }
        }
    }

    async function getBranchDetails() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-branches`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)

        if (body.operation == "success") {
            setBranchlist(body.data);
            let t = body.data.find(x => x.default_branch == "yes")
            setSelectedBranch({ label: t.branch_name, value: t.branch_id })
        }
        else {
            throw "branch list api error"
        }
    }

    async function getTransactionSeriesList() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-transaction-series-list`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)
        if (body.operation == "success") {
            setTransactionSeriesList(body.data)
        }
        else {
            throw "transaction series api list error"
        }
    }

    async function getInvoiceListBySearch(search_v, flag) {
        let api = "get-dealer-invoice-by-search";
        if (flag == "Customer Order") {
            api = "get-customer-invoice-by-search";
        }
        else if (flag == "Ecommerce Order") {
            api = "get-ecommerce-invoice-by-search";
        }
        setInvoiceListApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/${api}`, { method: 'POST', body: JSON.stringify({ "email": user.email, "search_value": search_v, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        setInvoiceListApiState(false)
        setInvoiceList(body.data.map(x => {
            if (flag == "Customer Order") {
                return { label: x.customer_invoice_number, value: x.customer_invoice_id, challans: x.challans }
            }
            else {
                return { label: x.invoice_number, value: x.invoice_id, challans: x.challans }
            }
        }))
    }

    useEffect(() => {
        if ((orderDetails != null) && (branchList.length > 0) && (transactionSeriesList.length > 0) && (warehouseList.length > 0) && (vehicleList.length > 0) && (deliveryAgentList.length > 0) && (shippingProviderList.length > 0)) {
            setSelectedBranch({ label: branchList.find(x => x.branch_id == orderDetails.branch_id).branch_name, value: orderDetails.branch_id });
            setSelectedTransactionSeries({ label: transactionSeriesList.find(x => x.transaction_series_id == orderDetails.transaction_series_id).series_name, value: orderDetails.transaction_series_id });
            setOrderNumber(orderDetails.order_number)
            setOrderType(orderDetails.order_type)
            setCourierName(orderDetails.courier_name)
            const vehicle_info = vehicleList.find(x => x.vehicle_information_id == orderDetails.vehicle_information_id);
            const shipping_provider_info = shippingProviderList.find(x => x.shipping_provider_id == orderDetails.shipping_provider_id);
            const delivery_agent_info = deliveryAgentList.find(x => x.delivery_agent_uid == orderDetails.delivery_agent_id);
            setSelectedVehicle({ label: `${vehicle_info.vehicle_id} - ${vehicle_info.vehicle_number} - ${vehicle_info.vehicle_model}`, value: vehicle_info.vehicle_information_id })
            setShippingProvider({ label: shipping_provider_info.name, value: orderDetails.shipping_provider_id })
            setSelectedDeliveryAgent({ agent_name: delivery_agent_info.agent_name, agent_uid: orderDetails.delivery_agent_id, agent_phone: delivery_agent_info.agent_phone })
            setDistanceDetails(orderDetails.distance_details)
            setCourierTrackingId(orderDetails.courier_tracking_id)
            setDeliveryChalanArray(orderDetails.delivery_challan_array)
            setSelectedInvoice({ label: orderDetails.invoice_number, value: orderDetails.invoice_id })
            setOrderDate(moment(orderDetails.order_date).format('YYYY-MM-DD'))
            setSelectedWarehouse({ label: warehouseList.find(x => x.wid == orderDetails.warehouse_id).name, value: orderDetails.warehouse_id })
        }
    }, [orderDetails, branchList, transactionSeriesList, warehouseList, vehicleList, deliveryAgentList, shippingProviderList])

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            let p1 = getOrderDetails()
            let p2 = getAllShippingProvider()
            let p3 = getBranchDetails()
            let p4 = getTransactionSeriesList()
            let p5 = getWarehouses()
            let p6 = getVehicleInformationBySearch()
            let p7 = getDeliveryAgentBySearch();

            Promise.all([p1, p2, p3, p4, p5, p6, p7])
                .then(() => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    console.log(err)
                })
        }

    }, [user, visibility, read, write])

    const newDeliveryAgentSubmit = () => {

        if (deliveryAgentName == "") {
            swal("Oops!", "Delivery Agent Name cannot be empty", "error");
            return
        }
        if (deliveryAgentPhone == "") {
            swal("Oops!", "Delivery Agent Phone cannot be empty", "error");
            return
        }
        let reg1 = /^\+?[0-9]\d{1,20}$/
        if (!reg1.test(deliveryAgentPhone)) {
            swal("Oops!", "Enter Valid Phone", "error");
            return
        }

        let reg2 = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-]+)(\.[a-zA-Z]{2,5}){1,2}$/
        if ((deliveryAgentEmail != "") && (!reg2.test(deliveryAgentEmail))) {
            swal("Oops!", "Enter a valid email", "error");
            return
        }

        var object = {};

        object.agent_name = deliveryAgentName
        object.agent_phone = deliveryAgentPhone
        object.agent_email = deliveryAgentEmail
        object.company_name = deliveryAgentCompanyName
        object.company_phone = deliveryAgentCompanyPhone
        object.company_website = deliveryAgentCompanyWebsite
        object.company_address = deliveryAgentCompanyAddress

        object.organization_id = organization_id;
        object.page_name = page_name;

        console.log(object);
        setDeliveryAgentSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/add-delivery-agent`, object, headers).then((res) => {
            setDeliveryAgentSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", "Delivery Agent added successfully!", "success")

                handleAddDeliveryAgentModalClose()
            }
            else {
                swal("Oops!", res.data.message, "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const handleAddDeliveryAgentModalClose = () => {
        setAddDeliveryAgentModalShow(false)

        setDeliveryAgentName("")
        setDeliveryAgentPhone("")
        setDeliveryAgentEmail("")
        setDeliveryAgentCompanyName("")
        setDeliveryAgentCompanyPhone("")
        setDeliveryAgentCompanyWebsite("")
        setDeliveryAgentCompanyAddress("")
    }

    const newDeliveryInvoiceSubmit = (val) => {
        if (orderType == null) {
            swal("Oops!", "Order Type cannot be empty", "error");
            return
        }

        if (selectedInvoice == null) {
            swal("Oops!", "Invoice cannot be empty", "error");
            return
        }

        if (orderDate == "") {
            swal("Oops!", "Order Date cannot be empty", "error");
            return
        }

        if (selectedBranch == null) {
            swal("Oops!", "Branch cannot be empty", "warning");
            return false
        }
        if (selectedTransactionSeries == null) {
            swal("Oops!", "Transaction Series cannot be empty", "warning");
            return false
        }

        for (let i = 0; i < deliveryChalanArray.length; i++) {
            let obj = deliveryChalanArray[i]
            if (obj.challan_number == null) {
                swal("Oops!", "Choose an Challan", "error");
                return
            }
            if (obj.challan_date == "") {
                swal("Oops!", "Enter an Challan Date", "error");
                return
            }
        }

        if (deliveryChalanArray.length > 1) {
            let uniqueArray = []
            let duplicateArray = []

            deliveryChalanArray.map(x => x.challan_number).forEach(x => {
                if (uniqueArray.includes(x)) {
                    duplicateArray.push(x)
                } else {
                    uniqueArray.push(x)
                }
            })

            if (duplicateArray.length > 0) {
                swal("Oops!", `${duplicateArray.join(", ")} are duplicates`, "error");
                return
            }
        }

        if (shippingProvider == null) {
            swal("Oops!", "Select a Shipping Provider", "error");
            return
        }
        if (selectedDeliveryAgent == null) {
            swal("Oops!", "Select a Delivery Agent", "error");
            return
        }
        if (selectedWarehouse == null) {
            swal("Oops!", "Select a Warehouse", "error");
            return
        }
        if (distanceDetails.input_km <= 0) {
            swal("Oops!", "Enter a valid distance in km", "error");
            return
        }

        if (selectedVehicle == null) {
            swal("Oops!", "Vehicle No. cannot be empty", "error");
            return
        }

        if (!courierName) {
            swal("Oops!", "Courier Name cannot be empty", "error");
            return
        }
        if (!courierTrackingId) {
            swal("Oops!", "Courier Tracking Id cannot be empty", "error");
            return
        }

        var object = {};
        object.delivery_order_id = props.match.params.id;
        object.order_date = orderDate
        object.order_id = orderNumber
        object.delivery_challan_array = deliveryChalanArray

        object.order_type = orderType
        object.selected_invoice = selectedInvoice

        object.branch_id = selectedBranch.value
        object.transaction_series_id = selectedTransactionSeries.value

        object.shipping_provider = { shipping_provider_id: shippingProvider.value, shipping_provider_name: shippingProvider.label }
        object.delivery_agent = { agent_id: selectedDeliveryAgent.agent_uid, agent_name: selectedDeliveryAgent.agent_name, agent_phone: selectedDeliveryAgent.agent_phone }

        object.selected_warehouse = selectedWarehouse.value
        object.distance_details = distanceDetails

        const vehicle_info = vehicleList.find(x => x.vehicle_information_id == selectedVehicle.value);
        object.vehicle_details = { vehicle_information_id: vehicle_info.vehicle_information_id, vehicle_id: vehicle_info.vehicle_id, vehicle_type: vehicle_info.vehicle_type, vehicle_number: vehicle_info.vehicle_number };
        object.courier_name = courierName
        object.courier_tracking_id = courierTrackingId

        object.save_flag = val

        object.organization_id = organization_id;
        object.page_name = page_name;

        setDeliveryInvoiceSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/update-delivery-order`, object, headers).then((res) => {
            setDeliveryInvoiceSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", `Delivery Order updated successfully!`, "success").then((value) => {
                    window.location.reload();
                });
            }
            else {
                swal("Oops!", res.data.message, "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const handleAddressModalClose = () => {
        setAddressModalShow(false)

        setAddressType(null)
        setInvoiceIndexAddress(null)
        setAddressId(null)
    }

    const handleGstinModalClose = () => {
        setGstinModalShow(false)

        setInvoiceIndexGstin(null)
        setGstinId(null)
    }

    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Edit Delivery Order</h1>
                </div>
                <div>
                    {
                        state == 1 ?
                            <>
                                <div className='card'>
                                    <div className='card-body'>
                                        <div className="row mb-5">
                                            <div className="col-md-4 mb-2">
                                                <label className="fs-5 fw-bold mb-2 required">Order Type</label>
                                                <Select
                                                    options={["Dealer Order", "Customer Order", "Ecommerce Order"].map(x => { return { label: x, value: x } })}
                                                    value={orderType === null ? null : { label: orderType, vale: orderType }}
                                                    onChange={(val) => { setOrderType(val.value); setSelectedInvoice(null); setInvoiceList([]); getInvoiceListBySearch("", val.value) }}
                                                    isClearable
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                    placeholder="Choose Order Type"
                                                    isDisabled
                                                />
                                            </div>
                                            <div className="col-md-4 mb-2">
                                                <label className="fs-5 fw-bold mb-2 required">Select Invoice</label>
                                                <Select
                                                    options={invoiceList}
                                                    value={selectedInvoice}
                                                    onChange={(val) => { setSelectedInvoice(val); setChalanList(val.challans); }}
                                                    onInputChange={(val) => { (val.length > 2) && getInvoiceListBySearch(val, orderType) }}
                                                    onMenuClose={() => { getInvoiceListBySearch("", orderType); }}
                                                    isLoading={invoiceListApiState}
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                    placeholder="Choose Invoice"
                                                    isDisabled
                                                />
                                            </div>
                                            <div className="col-md-4 mb-2">
                                                <label className="fs-5 fw-bold mb-2 required">Order Date</label>
                                                <input type="date" className="form-control form-control-solid" max={new Date().toISOString().split('T')[0]} value={orderDate} onChange={(e) => { setOrderDate(e.target.value) }} />
                                            </div>
                                        </div>
                                        <div className="row mb-5">
                                            <div className="col-md-4 px-1 mb-2">
                                                <label className="required fs-5 fw-bold mb-2">Branch:</label>
                                                <Select
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                    options={branchList.map((x) => { return { label: x.branch_name, value: x.branch_id } })}
                                                    onChange={(val) => {
                                                        setSelectedBranch(val);
                                                        setSelectedTransactionSeries(null)
                                                    }}
                                                    value={selectedBranch}
                                                    placeholder="Select Branch"
                                                    isDisabled
                                                />
                                            </div>
                                            <div className="col-md-4 px-1 mb-2">
                                                <label className="required fs-5 fw-bold mb-2">Transaction Series:</label>
                                                <Select
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                    options={selectedBranch != null && transactionSeriesList.filter(x => branchList.find(a => a.branch_id == selectedBranch.value).transaction_series_id.split(",").includes(x.transaction_series_id)).map(x => { return { label: x.series_name, value: x.transaction_series_id } })}
                                                    onChange={(val) => { setSelectedTransactionSeries(val); }}
                                                    value={selectedTransactionSeries}
                                                    placeholder="Select Transaction Series"
                                                    isDisabled
                                                />
                                            </div>
                                            <div className="col-md-4 mb-2">
                                                <label className="fs-5 fw-bold mb-2">Order Number</label>
                                                <input type="text" className="form-control form-control-solid" value={orderNumber} disabled readOnly />
                                            </div>

                                            {/* <div className="col-md-4">
                                                    <label className="fs-5 fw-bold mb-2">Date of Delivery Initiated</label>
                                                    <input type="date" className="form-control form-control-solid" value={moment.utc().format("YYYY-MM-DD")} disabled readOnly />
                                                </div> */}
                                        </div>



                                        <div className='container-fluid'>
                                            {
                                                deliveryChalanArray.map((obj, i) => {
                                                    return (
                                                        <div key={i} className='container bg-secondary my-2 p-5 rounded'>
                                                            <div className='d-flex align-items-center justify-content-between mb-3'>
                                                                <div className='fs-4 fw-bold'>Chalan: #{i + 1}</div>
                                                                <div>

                                                                    {
                                                                        deliveryChalanArray.length > 1 &&
                                                                        <button className='btn btn-link text-hover-danger mx-3'
                                                                            onClick={() => {
                                                                                let t = deliveryChalanArray.map(x => { return { ...x } })
                                                                                t.splice(i, 1)
                                                                                setDeliveryChalanArray(t)
                                                                            }}
                                                                        >&#10006;</button>
                                                                    }
                                                                </div>
                                                            </div>

                                                            <div className="row mb-5 gx-0 ">
                                                                <div className="col-md-4 px-1 mb-2">
                                                                    <label className="fs-5 fw-bold mb-2 required">Chalan No.</label>
                                                                    <Select
                                                                        options={chalanList.map(x => { return { label: x.delivery_challan_number, value: x.delivery_challan_id } })}
                                                                        value={obj.challan_number == null ? null : { label: obj.challan_number, value: obj.challan_id }}
                                                                        onChange={(val) => {
                                                                            let inv_d = chalanList.find(x => x.delivery_challan_id == val.value)
                                                                            let t = deliveryChalanArray.map(x => { return { ...x } })
                                                                            t[i].challan_number = val.label
                                                                            t[i].challan_id = val.value
                                                                            t[i].challan_date = moment(inv_d.chalan_date).format("YYYY-MM-DD")
                                                                            setDeliveryChalanArray(t);
                                                                        }}
                                                                        isLoading={chalanListApiState}
                                                                        styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                        placeholder="Select chalan"
                                                                    />
                                                                </div>
                                                                <div className="col-md-3 mb-2">
                                                                    <label className="fs-5 fw-bold mb-2 required">Chalan Date</label>
                                                                    <input type="date" className="form-control form-control-solid" max={new Date().toISOString().split('T')[0]} value={obj.challan_date} disabled={!obj.invoice_external} readOnly={!obj.invoice_external}
                                                                        onChange={(e) => {
                                                                            let t = deliveryChalanArray.map(x => { return { ...x } })
                                                                            t[i].challan_date = e.target.value
                                                                            setDeliveryChalanArray(t);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                            <button className='btn btn-primary btn-sm m-3' onClick={() => { setDeliveryChalanArray([...deliveryChalanArray, { challan_number: null, challan_id: null, challan_date: moment.utc().format('YYYY-MM-DD'), invoice_external: false, dealer_id: null, dealer_name: null, dealer_email: null, billing_address: null, shipping_address: null, gstin_details: null, responsible_agent: null, agent_manager: null }]) }}>+ Add Chalan</button>
                                        </div>

                                        <div className="row mb-5">
                                            <div className="col-md-6 mb-2">
                                                <label className="fs-5 fw-bold mb-2 required">Shipping Provider</label>
                                                <Select
                                                    options={shippingProviderList.map(x => { return { label: x.name, value: x.shipping_provider_id } })}
                                                    value={shippingProvider}
                                                    onChange={(val) => { setShippingProvider(val); }}
                                                    isLoading={shippingProviderListApiState}
                                                    isClearable
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                    placeholder="Choose Shipping Provider"
                                                />
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="fs-5 fw-bold mb-2 required">Delivery Agent</label>
                                                <Select
                                                    options={deliveryAgentList.map(x => { return { label: x.agent_name, value: x.delivery_agent_uid } })}
                                                    value={selectedDeliveryAgent == null ? null : { label: selectedDeliveryAgent.agent_name, value: selectedDeliveryAgent.agent_uid }}
                                                    onChange={(val) => { setSelectedDeliveryAgent({ agent_name: val.label, agent_uid: val.value, agent_phone: deliveryAgentList.find(x => x.delivery_agent_uid == val.value).agent_phone }); }}
                                                    onInputChange={(val) => { (val.length > 2) && getDeliveryAgentBySearch(val) }}
                                                    onMenuClose={() => { getDeliveryAgentBySearch(); }}
                                                    isLoading={deliveryAgentListApiState}
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                    placeholder="Choose Delivery Agent"
                                                />
                                            </div>
                                        </div>

                                        <div className="row mb-5">
                                            <div className="col-md-4 mb-2">
                                                <label className="fs-5 fw-bold mb-2 required">Warehouse</label>
                                                <Select
                                                    options={warehouseList.map(x => { return { label: x.name, value: x.wid } })}
                                                    value={selectedWarehouse}
                                                    onChange={(val) => { setSelectedWarehouse(val); }}
                                                    isClearable
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                    placeholder="Select Warehouse..."
                                                />
                                            </div>
                                            <div className="col-md-4 mb-2">
                                                <label className="fs-5 fw-bold mb-2 required">Select Vehicle</label>
                                                <Select
                                                    options={vehicleList.map(x => { return { label: `${x.vehicle_id} - ${x.vehicle_number} - ${x.vehicle_model}`, value: x.vehicle_information_id } })}
                                                    value={selectedVehicle}
                                                    onChange={(val) => { setSelectedVehicle(val); }}
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                    onInputChange={(val) => { (val.length > 2) && getVehicleInformationBySearch(val) }}
                                                    isLoading={vehicleListApiState}
                                                    isClearable
                                                //placeholder="Select Warehouse..."
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fs-5 fw-bold mb-2 required">Distance(km) to Supply Destination</label>
                                                <input type="number" min={0} className="form-control form-control-solid" value={distanceDetails.input_km.toString()} onChange={(e) => { setDistanceDetails({ ...distanceDetails, input_km: e.target.value == "" || parseInt(e.target.value) < 0 ? 0 : parseInt(e.target.value) }) }} />
                                            </div>
                                        </div>
                                        <div className="row mb-5">
                                            <div className="col-md-6 mb-2">
                                                <label className={`fs-5 fw-bold mb-2 required`}>Courier Name</label>
                                                <input type="text" className="form-control form-control-solid" value={courierName} onChange={(e) => { setCourierName(e.target.value) }} />
                                            </div>
                                            <div className="col-md-6">
                                                <label className={`fs-5 fw-bold mb-2 required`}>Courier Tracking Id</label>
                                                <input type="text" className="form-control form-control-solid" value={courierTrackingId} onChange={(e) => { setCourierTrackingId(e.target.value) }} />
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                {
                                    write == 1 &&
                                    <button type="button" className="btn btn-lg btn-primary mt-15 mx-3 rounded" data-kt-indicator={deliveryInvoiceSubmitButtonState ? "on" : "off"} disabled={deliveryInvoiceSubmitButtonState} onClick={() => { newDeliveryInvoiceSubmit(false) }}>
                                        <span className="indicator-label">Save as Draft</span>
                                        <span className="indicator-progress">Please wait...
                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </span>
                                    </button>
                                }

                                {
                                    write == 1 &&
                                    <button type="button" className="btn btn-lg btn-info mt-15 mx-3 rounded" data-kt-indicator={deliveryInvoiceSubmitButtonState ? "on" : "off"} disabled={deliveryInvoiceSubmitButtonState} onClick={() => { newDeliveryInvoiceSubmit(true) }}>
                                        <span className="indicator-label">Save</span>
                                        <span className="indicator-progress">Please wait...
                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </span>
                                    </button>
                                }
                            </>
                            :
                            state == 2 ?
                                <div className="card">
                                    <div className="card-body pt-6">
                                        <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                    </div>
                                </div>
                                :
                                <PageError />
                    }
                </div>
            </div>

            <Modal show={addDeliveryAgentModalShow} onHide={() => { handleAddDeliveryAgentModalClose() }} size='lg' centered>
                <Modal.Header>
                    <Modal.Title>Add Agent</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleAddDeliveryAgentModalClose() }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container px-1'>

                        <div className="row mb-5">
                            <div className="col-md-6">
                                <label className="required fs-5 fw-bold mb-2">Delivery Agent Name</label>
                                <input type="text" className="form-control form-control-solid" value={deliveryAgentName} onChange={(e) => { setDeliveryAgentName(e.target.value) }} placeholder="Delivery Agent Name" />
                                <span className="form-text text-muted">Please enter Delivery Agent name.</span>
                            </div>
                            <div className="col-md-6">
                                <label className="required fs-5 fw-bold mb-2">Delivery Agent Phone</label>
                                <input className="form-control form-control-solid" value={deliveryAgentPhone} onChange={(e) => { setDeliveryAgentPhone(e.target.value) }} placeholder="Delivery Agent Phone" />
                            </div>
                        </div>

                        <div className="row mb-5">
                            <div className="col-md-6">
                                <label className="fs-5 fw-bold mb-2">Delivery Agent Email</label>
                                <input type="text" className="form-control form-control-solid" value={deliveryAgentEmail} onChange={(e) => { setDeliveryAgentEmail(e.target.value) }} placeholder="Delivery Agent Email" />
                            </div>
                            <div className="col-md-6">
                                <label className="fs-5 fw-bold mb-2">Company Name</label>
                                <input className="form-control form-control-solid" value={deliveryAgentCompanyName} onChange={(e) => { setDeliveryAgentCompanyName(e.target.value) }} placeholder="Company Name" />
                            </div>
                        </div>

                        <div className="row mb-5">
                            <div className="col-md-6">
                                <label className="fs-5 fw-bold mb-2">Company Phone</label>
                                <input type="text" className="form-control form-control-solid" value={deliveryAgentCompanyPhone} onChange={(e) => { setDeliveryAgentCompanyPhone(e.target.value) }} placeholder="Company Phone" />
                            </div>
                            <div className="col-md-6">
                                <label className="fs-5 fw-bold mb-2">Company Website</label>
                                <input className="form-control form-control-solid" value={deliveryAgentCompanyWebsite} onChange={(e) => { setDeliveryAgentCompanyWebsite(e.target.value) }} placeholder="Company Website" />
                            </div>
                        </div>

                        <div className="row mb-5">
                            <div className="col-md-12">
                                <label className="fs-5 fw-bold mb-2">Company Address</label>
                                <input type="text" className="form-control form-control-solid" value={deliveryAgentCompanyAddress} onChange={(e) => { setDeliveryAgentCompanyAddress(e.target.value) }} placeholder="Company Address" />
                            </div>
                        </div>

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { handleAddDeliveryAgentModalClose() }}>Close</button>
                    {
                        write == 1 &&
                        <button className="btn btn-success rounded" data-kt-indicator={deliveryAgentSubmitButtonState ? "on" : "off"} disabled={deliveryAgentSubmitButtonState} onClick={() => { newDeliveryAgentSubmit() }}>
                            <span className="indicator-label">+ Add</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    }
                </Modal.Footer>
            </Modal>
        </>
    );
}


export default EditDeliveryOrder;